/*
 * Template Product
 * -------------------
 * This file contains scripts for the product template.
 */

import BiggerPicture from 'bigger-picture';
// Import bigger-picture styles
import 'bigger-picture/dist/bigger-picture.css';
// Import product modules
import '../modules/product-info';
import '../modules/product-form';

// Make BiggerPicture available globally for existing code
window.BiggerPicture = BiggerPicture;
